// ======================= Imports =======================
import React, { useState, useRef } from "react";
import "./css/add_billingmodel.css";
import AddBillingModelNew from "./AddBillingModel/AddBillingModel";
import { Toast } from "primereact/toast";
import AddInventoryAgainstBillingModel from "./addbillingmodelinventory/AddBillingModelnventory";
import { Dialog } from "primereact/dialog";

// ======================= Main Component =======================
export default function AddBillingModel({
  setRefresh,
  setAddBillingModelVisibility,
}) {
  // ======================= State Management =======================

  const [addBillingModelDialog, setAddBillingModelDialog] = useState(false);
  const toast = useRef(null);

  // ======================= Fetch Billing Model List =======================

  // ======================= Render =======================
  return (
    <div className="flex flex-wrap  justify-content-around flex-row">
      <AddInventoryAgainstBillingModel
        setRefresh={setRefresh}
        setAddBillingModelVisibility={setAddBillingModelVisibility}
      />
      <Toast ref={toast} />
      <Dialog
        visible={addBillingModelDialog}
        onHide={() => {
          setAddBillingModelDialog(false);
        }}
        header="Add Billing Model"
      >
        <AddBillingModelNew
          setAddBillingModelDialog={setAddBillingModelDialog}
        />
      </Dialog>
    </div>
  );
}
